import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Film } from "lucide-react";

// Loads an access-controlled video via the API (sends auth cookie) as a blob.
export default function AuthVideo({ path, className = "", controls = true, muted = false, autoPlay = false, loop = false, poster }) {
  const [url, setUrl] = useState(null);
  const [err, setErr] = useState(false);
  useEffect(() => {
    let active = true; let objUrl = null;
    setErr(false); setUrl(null);
    if (!path) { setErr(true); return; }
    api.get(`/video/${path}`, { responseType: "blob" })
      .then((res) => { if (!active) return; objUrl = URL.createObjectURL(res.data); setUrl(objUrl); })
      .catch(() => active && setErr(true));
    return () => { active = false; if (objUrl) URL.revokeObjectURL(objUrl); };
  }, [path]);
  if (err) return <div className={`flex items-center justify-center bg-secondary text-muted-foreground ${className}`}><Film className="h-8 w-8 opacity-40" /></div>;
  if (!url) return <div className={`bg-secondary animate-pulse ${className}`} />;
  return <video src={url} className={className} controls={controls} muted={muted} autoPlay={autoPlay} loop={loop} playsInline poster={poster} data-testid="auth-video" />;
}
